<template>
  <div class="custom-card w-100">
    <div class="flex items-start">
      <img
        src="@/assets/images/icons/back-icon.svg"
        @click="moveBack"
        class="mr-2 mt-1 cursor-pointer"
        alt="Attach Image"
      />
      <page-header
        title="Roles & Privileges"
        class="page-chrum"
        breadcrumb="Dashboard > Settings > Roles & Privileges"
      />
    </div>
    <!-- Roles and Privileges page -->
     {{ JSON.stringify(createRole) }}
           <button @click="createRole = true">switch role</button>
    <div v-if="createRole === false">
      <roles-and-privileges-table
        :createRolefunc="createRoleFunc_"
        :createRole="createRole"
        @editRoles="editRolesAction"
        :shouldCreateNew="shouldCreateNew"
        :allRoles="allRoles"
      ></roles-and-privileges-table>
    </div>
    <!-- New Role page -->
    <div v-else>
      <h1 style="font-size:32px; font-weight:600; color: #10233E" class="my-5">
        {{ isNewRole ? "Create a New Role" : "Edit Role" }}
      </h1>
        <new-role
        
        @getRoles="$emit('getRoles')"
        @resetRoles="createRole = false"
       
        :editModule="editModule"
        :isNewRole="isNewRole"
      ></new-role>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PageHeader from "@/components/UI/NewPageHeader";
import RolesAndPrivilegesTable from "./RolesAndPrivilegesTable.vue";
import NewRole from "./NewRole.vue";

export default {
  components: {
    PageHeader,
    RolesAndPrivilegesTable,
    NewRole,
  },
  data() {
    return {
      createRole: false,
      editModule: {},
      isNewRole: true,
      rolePrivileges: {},
      allRoles: [],
    };
  },
   mounted() {
      this.getRoles();
    
    },
    computed: { 
      dateFilterpayload() {
      return {
        dateFilter: "custom",
        startDate: "2024-01-01",
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },
  },
  methods: {
    createRoleFunc_() {
      this.createRole = true
    },
    async getRoles() {
      try {
        const response = await this.$_getRoles(this.dateFilterpayload);
        this.allRoles = response.data.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getRoleUsers(role) {

      try {

        const response = await this.$_viewRole(role);
        if (response.data.success === false) {
          this.generateToast(response.data.message, "error");
          return;
        } else {
          this.rolePrivileges = response.data.data;
          
          this.editModule = this.rolePrivileges;
          
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.loadingPrivileges = false;
      }
    },
    moveBack() {
      if (this.createRole) {
        this.createRole = false;
      } else {
        this.$router.push("/3pl/dashboard");
      }
    },
    shouldCreateNew(val) {
      this.isNewRole = val;
      console.log("shouldCreateNew", val,  this.isNewRole);
    },
    editRolesAction(val) {
      this.getRoleUsers(val)
      // this.editModule = val;
      this.createRole = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-chrum {
  flex: 1;
}
</style>
